module.exports = __webpack_public_path__ + "static/media/picto-friends-full.71c34c37.svg";